/**
 * @generated SignedSource<<8ecb59397caeeba8b1f96e7ccfec494a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_ListView_project$data = {
  readonly key: string;
  readonly projectId: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ui_nativeIssueTable_NativeIssueTable_project">;
  readonly " $fragmentType": "main_issueNavigator_ListView_project";
};
export type main_issueNavigator_ListView_project$key = {
  readonly " $data"?: main_issueNavigator_ListView_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_ListView_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_ListView_project",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "projectId"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_nativeIssueTable_NativeIssueTable_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "704e90d839184a3c8963617bf36efd8c";

export default node;
